export default __webpack_public_path__ + "static/media/primary.95182409acb1e7499b9a3c6f7cb4ab8a.svg";